import type { TabsProps } from 'antd';
import { Tabs as BaseTabs } from 'antd';
import classNames from 'classnames';
import type { FC } from 'react';

export const Tabs: FC<TabsProps> = (props) => {
  // props
  const { items } = props;

  return (
    <BaseTabs
      {...props}
      animated
      renderTabBar={(props, DefaultTabBar) => {
        if (items) {
          const { activeKey, onTabClick } = props;

          return (
            <ul className="sticky -top-6 z-10 flex gap-8 justify-center items-center w-full h-12 bg-white text-sm text-secondary-1">
              {items.map((item) => {
                const { key, label, disabled } = item;

                return (
                  <li className="h-full" key={key}>
                    <button
                      type="button"
                      role="tab"
                      disabled={disabled}
                      className={classNames(
                        'relative h-full px-1 transition hover:font-medium',
                        {
                          'tab-item--active font-medium text-main':
                            key === activeKey,
                        },
                      )}
                      onClick={(e) => onTabClick(key, e)}
                    >
                      {label}
                    </button>
                  </li>
                );
              })}
            </ul>
          );
        }
        return <DefaultTabBar {...props} />;
      }}
    />
  );
};
